import { access } from 'fs';

('use strict');

const parsePolygonCoordinates = function(data) {
  let results = [];
  data.forEach(polyObj => {
    //console.info(polyObj);

    const polyObjCopy = {
      leadAgency: polyObj.leadAgency,
      lga: polyObj.lga,
      supportingAgencies: polyObj.supportingAgencies,
      size: polyObj.size,
      location: polyObj.location,
      guarReference: polyObj.guarReference,
      geometryType: polyObj.geometryType,
      tenure: polyObj.tenure,
      startDate: polyObj.startDate,
      endDate: polyObj.endDate,
    };
    //delete polyObjCopy.polygons;

    polyObj.polygons.forEach(item => {
      const processedResult = processPolygonCoordinates(item.polygon);
      processedResult.content = polyObjCopy;
      results.push(processedResult);
    });
  });
  return results;
};

const processPolygonCoordinates = polygonCoodString => {
  const rawCoords = polygonCoodString.split('|').slice(0, -1);
  let latLow, latHigh, lngLow, lngHigh;
  const coordinates = rawCoords.map(coordPair => {
    const coords = coordPair.split(';');
    const lat = Number(coords[0]);
    const lng = Number(coords[1]);

    if (!latLow || lat < latLow) latLow = lat;
    if (!latHigh || lat > latHigh) latHigh = lat;
    if (!lngLow || lng < lngLow) lngLow = lng;
    if (!lngHigh || lng > lngHigh) lngHigh = lng;
    return {
      lat: lat,
      lng: lng,
    };
  });

  const center = {
    lat: latLow + (latHigh - latLow) / 2,
    lng: lngLow + (lngHigh - lngLow) / 2,
  };

  return {
    center,
    coordinates,
  };
};

export default parsePolygonCoordinates;
